import React from 'react';

const icon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 19">
    <path fill="#ff5f00" d="M10.94 2.031h8.112v14.938H10.94z" />
    <path fill="#eb001b" d="M11.46 9.5c-.003-2.915 1.302-5.67 3.54-7.469C11.2-1.03 5.74-.585 2.46 3.055s-3.28 9.25 0 12.89S11.2 20.03 15 16.97c-2.238-1.8-3.543-4.554-3.54-7.469" />
    <path fill="#f79e1b" d="M29.992 9.5c0 3.637-2.026 6.955-5.219 8.544a9.09 9.09 0 0 1-9.78-1.075c2.235-1.802 3.54-4.555 3.54-7.47 0-2.913-1.305-5.666-3.54-7.468a9.09 9.09 0 0 1 9.78-1.076c3.193 1.59 5.22 4.908 5.219 8.545" />
  </svg>
);

export default icon;
